export default __webpack_public_path__ + "static/media/square_logo.610763b6.gif";